import { Path } from 'react-native-svg';
import React from 'react';

import { IconDef, IconSpecificStyles } from './types';

export const Burger: IconDef = {
  svg: (
    <Path
      strokeLinecap="round"
      d="M2 11.9987H15.3333M2 5.33203H22M2 18.6654H22"
    />
  ),
  svgStyles(color): IconSpecificStyles {
    return {
      stroke: color,
      strokeWidth: 2,
    };
  },
};
